<mat-card style="padding: 0px;">
  <nav class="product-tabs" aria-label="Produtos SRM, SRP, PSRM e PSC">
      <a
        class="product-tab"
        [routerLink]="['/srm/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        SRM
      </a>
      <a
        class="product-tab"
        [routerLink]="['/srp/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        SRP
      </a>
      <a
        class="product-tab"
        [routerLink]="['/spr/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        PSRM
      </a>
      <a
        class="product-tab active"
        [routerLink]="['/spc/municipio', ufSelecionada || 'BR']"
        [queryParams]="currentQueryParams"
      >
        PSC
      </a>
    </nav>

  <mat-card-header>
    <mat-card-title>Persistência de Seca por Categoria</mat-card-title>
  </mat-card-header>

  <mat-progress-bar mode="indeterminate" [class.show]="loading" [class.hide]="!loading"></mat-progress-bar>
  <mat-divider></mat-divider>
  <mat-progress-bar mode="indeterminate" [class.show]="loading" [class.hide]="!loading"></mat-progress-bar>

  <mat-card-content>
    

    <div class="selector-layout">
      <div class="selector">
        <mat-form-field>
          <mat-label>Filtrar por Estado</mat-label>
          <mat-select [value]="ufSelecionada" (selectionChange)="navegarParaUf($event.value)">
            <mat-option *ngFor="let uf of ufs" [value]="uf.sigla">
              {{ uf.nome }} - {{ uf.sigla }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Mês/Ano</mat-label>
          <mat-select [(value)]="dataSelecionada" (selectionChange)="onDataChange()">
            <mat-option *ngFor="let data of datas" [value]="data">
              {{ data }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-card class="description-card">
        <mat-card-content>
          <p>
            A <b>Persistência de Seca por Categoria (PSC)</b> apresenta uma abordagem complementar da continuidade da seca ao longo do tempo, ao analisar a permanência do fenômeno em cada uma das cinco categorias adotadas pelo Monitor.
A PSC tem como diferencial a possibilidade de contabilização do tempo acumulado de ocorrência da seca desde o seu início, incluindo eventuais períodos de intensificação. Diferentemente da Persistência de Seca Relativa Máxima (PSRM), sua contagem não está condicionada à Seca Relativa Máxima (SRM) vigente, não havendo, portanto, interrupção da contagem quando ocorre mudança de categoria.
          </p>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="cards-row">
  <mat-card class="card card--small">
        <mat-card-title>País</mat-card-title>
        <div class="ufs">
          <!-- país -->
          <a
            class="uf-chip"
            *ngFor="let p of paises"
            [routerLink]="['/spc/municipio', p.sigla]"
            [queryParams]="currentQueryParams"
            [class.active]="ufSelecionada === p.sigla"
          >
            {{ p.sigla }}
          </a>
        </div>
      </mat-card>

      <mat-card class="card">
        <mat-card-title>Estados (UF)</mat-card-title>
        <div class="ufs">
          <!-- estados -->
          <a
            class="uf-chip"
            *ngFor="let uf of ufs"
            [routerLink]="['/spc/municipio', uf.sigla]"
            [queryParams]="currentQueryParams"
            [class.active]="ufSelecionada === uf.sigla"
          >
            {{ uf.sigla }}
          </a>
        </div>
      </mat-card>
    </div>

    <div class="spc-images">
      <div class="spc-image" *ngIf="imagemSpcS0Url as imagemUrl">
        <mat-progress-bar mode="indeterminate" *ngIf="spcS0Loading"></mat-progress-bar>
        <div class="image-wrapper">
          <div class="download-actions" *ngIf="!spcS0Error">
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="imagemUrl"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar imagem PNG"
              aria-label="Baixar imagem PNG">
              <mat-icon>image</mat-icon>
            </a>
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="toGpkgUrl(imagemUrl)"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar GPKG"
              aria-label="Baixar GPKG">
              <img src="assets/img/gpkg_icon.png"
              alt="Baixar GPKG"
              class="download-img-icon">
            </a>
          </div>
          <img
            *ngIf="!spcS0Error"
            [src]="imagemUrl"
            alt="SPC S0"
            class="img-responsive"
            (load)="onSpcS0Load()"
            (error)="onSpcS0Error()"
          />
          <div class="image-placeholder" *ngIf="spcS0Error">Aguardando Imagem</div>
        </div>
      </div>
      <div class="spc-image" *ngIf="imagemSpcS1Url as imagemUrl">
        <mat-progress-bar mode="indeterminate" *ngIf="spcS1Loading"></mat-progress-bar>
        <div class="image-wrapper">
          <div class="download-actions" *ngIf="!spcS1Error">
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="imagemUrl"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar imagem PNG"
              aria-label="Baixar imagem PNG">
              <mat-icon>image</mat-icon>
            </a>
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="toGpkgUrl(imagemUrl)"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar GPKG"
              aria-label="Baixar GPKG">
              <img src="assets/img/gpkg_icon.png"
              alt="Baixar GPKG"
              class="download-img-icon">
            </a>
          </div>
          <img
            *ngIf="!spcS1Error"
            [src]="imagemUrl"
            alt="SPC S1"
            class="img-responsive"
            (load)="onSpcS1Load()"
            (error)="onSpcS1Error()"
          />
          <div class="image-placeholder" *ngIf="spcS1Error">Aguardando Imagem</div>
        </div>
      </div>
      <div class="spc-image" *ngIf="imagemSpcS2Url as imagemUrl">
        <mat-progress-bar mode="indeterminate" *ngIf="spcS2Loading"></mat-progress-bar>
        <div class="image-wrapper">
          <div class="download-actions" *ngIf="!spcS2Error">
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="imagemUrl"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar imagem PNG"
              aria-label="Baixar imagem PNG">
              <mat-icon>image</mat-icon>
            </a>
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="toGpkgUrl(imagemUrl)"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar GPKG"
              aria-label="Baixar GPKG">
              <img src="assets/img/gpkg_icon.png"
              alt="Baixar GPKG"
              class="download-img-icon">
            </a>
          </div>
          <img
            *ngIf="!spcS2Error"
            [src]="imagemUrl"
            alt="SPC S2"
            class="img-responsive"
            (load)="onSpcS2Load()"
            (error)="onSpcS2Error()"
          />
          <div class="image-placeholder" *ngIf="spcS2Error">Aguardando Imagem</div>
        </div>
      </div>
      <div class="spc-image" *ngIf="imagemSpcS3Url as imagemUrl">
        <mat-progress-bar mode="indeterminate" *ngIf="spcS3Loading"></mat-progress-bar>
        <div class="image-wrapper">
          <div class="download-actions" *ngIf="!spcS3Error">
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="imagemUrl"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar imagem PNG"
              aria-label="Baixar imagem PNG">
              <mat-icon>image</mat-icon>
            </a>
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="toGpkgUrl(imagemUrl)"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar GPKG"
              aria-label="Baixar GPKG">
              <img src="assets/img/gpkg_icon.png"
              alt="Baixar GPKG"
              class="download-img-icon">
            </a>
          </div>
          <img
            *ngIf="!spcS3Error"
            [src]="imagemUrl"
            alt="SPC S3"
            class="img-responsive"
            (load)="onSpcS3Load()"
            (error)="onSpcS3Error()"
          />
          <div class="image-placeholder" *ngIf="spcS3Error">Aguardando Imagem</div>
        </div>
      </div>
      <div class="spc-image" *ngIf="imagemSpcS4Url as imagemUrl">
        <mat-progress-bar mode="indeterminate" *ngIf="spcS4Loading"></mat-progress-bar>
        <div class="image-wrapper">
          <div class="download-actions" *ngIf="!spcS4Error">
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="imagemUrl"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar imagem PNG"
              aria-label="Baixar imagem PNG">
              <mat-icon>image</mat-icon>
            </a>
            <a
              mat-icon-button
              class="download-icon-btn"
              [href]="toGpkgUrl(imagemUrl)"
              target="_blank"
              rel="noopener noreferrer"
              title="Baixar GPKG"
              aria-label="Baixar GPKG">
              <img src="assets/img/gpkg_icon.png"
              alt="Baixar GPKG"
              class="download-img-icon">
            </a>
          </div>
          <img
            *ngIf="!spcS4Error"
            [src]="imagemUrl"
            alt="SPC S4"
            class="img-responsive"
            (load)="onSpcS4Load()"
            (error)="onSpcS4Error()"
          />
          <div class="image-placeholder" *ngIf="spcS4Error">Aguardando Imagem</div>
        </div>
      </div>
    </div>
  </mat-card-content>

  <!-- <mat-card class="card">
    <mat-card-content>
      <mat-card-title>Municípios (SPC)</mat-card-title>
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

      <div class="placeholder" *ngIf="!ufSelecionada">
        Escolha uma UF acima para carregar os municípios.
      </div>

      <ng-container *ngIf="ufSelecionada">
        <div *ngIf="dataSource.data?.length; else ufNaoImplementada">
          <div class="subtitulo">
            Listando todos os municípios da UF <strong>{{ ufSelecionada }}</strong>.
          </div>

          <div class="table-hover" #TABLE>
            <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
              <ng-container matColumnDef="nome">
                <mat-header-cell *matHeaderCellDef> Município </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.nome }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="semSeca">
                <mat-header-cell *matHeaderCellDef> Sem seca </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s0s4">
                <mat-header-cell *matHeaderCellDef> S0-S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s1s4">
                <mat-header-cell *matHeaderCellDef> S1-S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s2s4">
                <mat-header-cell *matHeaderCellDef> S2-S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s3s4">
                <mat-header-cell *matHeaderCellDef> S3-S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="s4">
                <mat-header-cell *matHeaderCellDef> S4 </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  0
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
          </div>
        </div>

        <ng-template #ufNaoImplementada>
          <div class="placeholder">
            Tabela detalhada de municípios ainda não implementada para a UF
            <strong>{{ ufSelecionada }}</strong>.
          </div>
        </ng-template>
      </ng-container>
    </mat-card-content>
  </mat-card> -->
</mat-card>
